/** zh-CN catalogue `wizard` (W3-09; English: src/features/wizard/wizard.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'wizard',
  locale: 'zh-CN',
  messages: {
    title: '新建谱面',
    stepsLabel: '新建谱面的步骤',
    stepState: '{n}. {title}（{state, select, done {已完成} skipped {暂时跳过} current {当前步骤} other {尚未完成}}）',
    back: '上一步',
    firstStep: '这是第一步。',
    nextBlocked: '请先完成此步骤，或暂时跳过。',
    nextBlockedSong: '请先选择一首 Phira 能播放的曲目。',
    next: '下一步：{step}',
    create: '创建谱面',
    creating: '正在创建谱面…',
    skip: '暂时跳过',
    cancel: '取消',
    discardTitle: '放弃这张新谱面？',
    discardBody: '曲目和你填写的信息尚未保存。',
    discardConfirm: '放弃',
    errorCreate: '无法创建谱面：{detail}',
    errorInvalid: '新谱面未通过文档检查（{detail}）。请报告此问题。',
    errorNoSong: '请先选择曲目。',
    errorPreview: '选曲预览必须位于曲目范围内。',
    persistRefused: '浏览器没有承诺保留你的谱面。请不时从谱面库下载备份。',
    tourOfferTitle: '要进行 2 分钟的导览吗？',
    tourOfferBody: '八个简短的步骤，在你的新谱面中演示判定线、播放、音符、运动和发布。',
    tourOfferStart: '开始导览',
    untitled: '未命名',
    stepSong: '曲目',
    stepPicture: '曲绘',
    stepDetails: '信息',
    stepStart: '开始',
    cmdNew: '新建谱面',
    settingCharter: '新谱面的谱师名',
    settingCharterHelp: '新建向导会自动填写它，并记住你上次输入的内容。',
    songDrop: '将曲目拖放到此处，或',
    chooseFile: '选择文件',
    songAccepted: 'MP3、OGG、WAV 或 FLAC。M4A 和 Opus 会被转换为 WAV。',
    songLoading: '正在读取曲目…',
    songFacts: '{duration} · {codec} · {rate} kHz · {channels, plural, =1 {单声道} =2 {立体声} other {# 声道}}',
    codecMp3: 'MP3',
    codecOgg: 'OGG Vorbis',
    codecWav: 'WAV',
    codecFlac: 'FLAC',
    codecAac: 'AAC',
    codecM4a: 'M4A（MP4 中的 AAC）',
    codecOpus: 'Opus',
    codecOther: '{codec}',
    verdictOk: 'Phira 可以播放此文件。',
    verdictMp3: 'Phira 可以播放此文件。使用 OGG 或 WAV 能让时间在各播放器中最精确（MP3 解码器有延迟）。',
    verdictNotForRpe: 'Phira 可以播放此文件，但 RPE 无法打开它。',
    verdictConvert: 'Phira 无法播放此格式。',
    convertToWav: '转换为 WAV',
    convertHint: '文件更大，但始终可用。',
    convertForRpe: '为 RPE 转换为 WAV',
    convertForRpeHint: '可选：只有在你也要用 RPE 打开谱面时才需要。',
    converting: '正在转换为 WAV…',
    converted: '已转换为 WAV（{size} MB）。',
    convertFailed: '转换失败：{detail}',
    chooseAnother: '选择其他文件',
    removeSong: '移除曲目',
    play: '播放',
    stop: '停止',
    playUnavailable: '此浏览器无法播放声音。',
    waveformLabel: '{name} 的波形',
    errNotAudio: '“{name}”不是音频文件。',
    errDecode: '浏览器无法解码“{name}”。请尝试 MP3、OGG 或 WAV 文件。',
    errTooShort: '曲目太短：至少需要 {min} 秒。',
    errRead: '无法读取文件：{detail}',
    detecting: '正在后台检测速度…',
    detected: '检测到速度：约 {bpm} BPM。可在“节拍”步骤中检查。',
    detectedNone: '未检测到明确的速度。可在“节拍”步骤中敲击得出速度。',
    detectFailed: '速度检测暂时不可用。可在“节拍”步骤中敲击得出速度。',
    picDrop: '将图片拖放到此处，或',
    picAccepted: 'PNG 或 JPG（到处可用）、WebP、BMP 或 GIF。',
    picLoading: '正在读取图片…',
    picFacts: '{w} x {h} px · {codec}',
    previewGame: '游戏中',
    previewGameHint: '模糊并调暗，与 Phira 在谱面背后绘制的效果相同。',
    previewSelect: '选曲界面',
    previewSelectHint: '裁剪为 16:9。',
    previewBusy: '正在绘制预览…',
    previewUnavailable: '预览暂时不可用。',
    picLarge: '这张图片为 {w} x {h} px。Phira 可以加载它，但最大 4096 px 的副本加载更快。',
    picDownscale: '使用 4096 px 的副本',
    picDownscaling: '正在生成较小的副本…',
    picUnsupported: 'Phira 无法显示此图片格式。',
    picConvert: '转换为 PNG',
    picConverting: '正在转换为 PNG…',
    picNotForRpe: 'RPE 只能打开 PNG 和 JPG 图片。',
    picRemove: '移除曲绘',
    picPlaceholder: '还没有曲绘：将使用根据标题生成的渐变图，“问题”会提醒你。随时可以在“素材”中选择曲绘。',
    picNotImage: '“{name}”不是图片。',
    picError: '无法读取图片：{detail}',
    fieldTitle: '曲名',
    fieldArtist: '曲师',
    fieldIllustrator: '画师',
    fieldCharter: '谱师',
    charterRemembered: '下次新建谱面时会记住。',
    prefilled: '已根据曲目文件填写。',
    titleRequired: '请输入曲名，或暂时跳过此步骤。',
    difficultyLabel: '难度',
    labelCustom: '自定义',
    customLabel: '自定义标签',
    levelNumber: '等级',
    levelPreview: '显示为“{level}”',
    previewTitle: '选曲预览',
    previewHint: '玩家选择谱面时会听到这段曲目。',
    previewStart: '开始于',
    previewEnd: '结束于',
    unitSeconds: '秒',
    previewPlay: '播放预览',
    previewNegative: '预览不能早于曲目开始。',
    previewOrder: '预览的结束必须晚于开始。',
    previewBeyond: '预览必须在曲目结束前至少 0.5 秒结束（最晚为 {max} 秒）。',
    previewNotFinite: '请输入秒数。',
    previewWaveformLabel: '带有预览范围的曲目波形；单击可将预览移到该处',
    noSongYet: '请先选择曲目：预览范围取决于曲目长度。',
    startIntro: '谱面要如何开始？',
    layoutsLabel: '初始布局',
    layoutOneLine: '一条判定线',
    layoutOneLineBody: '经典开局：一条判定线位于屏幕下方三分之一处。',
    layoutTwoLines: '两条判定线',
    layoutTwoLinesBody: '两条判定线，一上一下。',
    layoutEmpty: '空',
    layoutEmptyBody: '还没有判定线。请在判定线面板中添加。',
    layoutRpe24: 'RPE 风格 24 条判定线',
    layoutRpe24Body: '判定线 0 可见，判定线 1 到 23 隐藏：RPE 的常用模板。',
    lineMain: '主线',
    lineSecond: '副线',
    lineNumbered: '判定线 {n}',
    summaryTitle: '你的新谱面',
    summarySong: '曲目：{name}（{duration}）',
    summaryDetails: '{title} · {level}',
    summaryTiming: '速度 {bpm} BPM，第 0 拍位于 {offset} 秒',
    summaryTimingUnconfirmed: '速度 {bpm} BPM，第 0 拍位于 {offset} 秒（尚未确认）',
    remindTitle: '“问题”会提醒你：',
    remindBeat: '时间设置未确认：请在“曲目与时间”中设置速度和第 0 拍{key, select, none {} other {（{key}）}}。',
    remindPicture: '曲绘是自动生成的占位图。',
    remindDetails: '你跳过的曲目信息（曲名、曲师、画师、谱师）。',
    persistNote: '浏览器可能会询问是否允许此网站保留数据：请允许，这样你的谱面就不会被自动清理。',
  },
};

export default catalog;
